import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
// import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import CommonModal from "@/modules/common/components/ui-kit/modals/common-modal";
import WithResponsiveRendering from "@/modules/common/components/wrappers/with-responsive-rendering";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import SingleSelectSearch from "@/modules/common/components/input/single-autocomplete-search";
import useEditDeveloperUser from "../hooks/use-edit-developer-user.hook";
import { DeveloperTrack } from "../types";

interface EditDeveloperUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  track: DeveloperTrack | null;
  // Optionally pass hook values from parent for better state management
  hookValues?: ReturnType<typeof useEditDeveloperUser>;
}

const EditDeveloperUserModal: React.FC<EditDeveloperUserModalProps> = ({
  isOpen,
  onClose,
  track,
  hookValues,
}) => {
  // Use provided hook values or create internal state
  const internalHook = useEditDeveloperUser({ track });
  const {
    selectedUserUId,
    setSelectedUserUId,
    users,
    usersLoading,
    searchTerm,
    setSearchTerm,
    handleSubmit,
    isSubmitting,
    isValid,
  } = hookValues || internalHook;

  // Convert users to options format
  const userOptions = users.map((user) => ({
    value: user.uid,
    label: user.name,
    phoneNumber: user.phoneNumber,
  }));

  const handleConfirm = async () => {
    await handleSubmit();
  };

  const ResponsiveModal = useMemo(() => WithResponsiveRendering({
    MobileComponent: CommonModal,
    DesktopComponent: CommonModal,
  }), []);

  return (
    <ResponsiveModal
      open={isOpen}
      onClose={onClose}
      title="Re-assign agent"
      confirmButtonText="Save"
      cancelButtonText="Cancel"
      onConfirm={handleConfirm}
      isLoading={isSubmitting}
      isConfirmDisabled={!isValid}
      sx={{
        width: "400px",
        maxWidth: "90vw",
      }}
    >
      <Box sx={{ padding: nawyTheme.nawy.spacing.md, width: "100%" }}>
        {track && (
          <Box sx={{ marginBottom: nawyTheme.nawy.spacing.md }}>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#636363",
              }}
            >
              Reassigning agent for{" "}
              <Typography
                component="span"
                sx={{
                  fontWeight: 600,
                  color: "#313131",
                }}
              >
                {track.developerName}
              </Typography>{" "}
              track
            </Typography>
          </Box>
        )}

        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              color: nawyTheme.nawy.colors.semantic.text.secondary,
              marginBottom: nawyTheme.nawy.spacing.xxs,
            }}
          >
            Developer Agent
          </Typography>
          <SingleSelectSearch
            options={userOptions}
            isLoading={usersLoading}
            label=""
            value={selectedUserUId}
            onValueChange={(value) => setSelectedUserUId(value)}
            searchValue={searchTerm}
            onSearchValueChange={setSearchTerm}
            noOptionsText="No agents found"
            sx={{
              borderRadius: "8px",
            }}
          />
        </Box>
      </Box>
    </ResponsiveModal>
  );
};

export default EditDeveloperUserModal;

